/* import __COLOCATED_TEMPLATE__ from './sorter-button.hbs'; */
import { isArray } from '@ember/array';
import { computed } from '@ember/object';
import Component from '@ember/component';
import { deepEquals } from '../../utils/json-equality';
import { isAscending } from '../sq-sorter';

/**
### Overview

This component is yielded by `sq-sorter`. Clicking on it will trigger sorting by the sortKey given to this component. See `sq-sorter` for example usage.

### Parameters
@param {Action} [sort] Action that will be triggered on click. Will be assigned by `sq-sorter`.
@param {(String|String[])} [sortKey] The sortKey by which the content will be sorted when this component is clicked. It should be provided after this component is yielded.
@param {(String|String[])} [currentSortKey] The key currently being sorted by. It will be assigned by `sq-sorter`. If it matches `sortKey`, this component will have a caret.
@param {Boolean} [sortDefault] If the caret is shown, its direction will be determined by whether it is being sorted in the default order.
@param {String} [label] If no block is provided, the label will be displayed instead.
*/

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['sorter-button'],
  classNameBindings: ['caret'],
  attributeBindings: ['colspan', 'data-test-sorter-button'],
  'data-test-sorter-button': true,
  click() {
    if (this.sort) {
      this.sort(this.get('sortKey'));
    }
  },
  caret: computed('sortKey.0', 'currentSortKey', 'sortDefault', function () {
    if (deepEquals(this.get('sortKey'), this.get('currentSortKey'))) {
      const firstKey = isArray(this.get('sortKey')) ? this.get('sortKey')[0] : this.get('sortKey');
      let isSortedAscending = isAscending(firstKey);
      if (!this.get('sortDefault')) {
        isSortedAscending = !isSortedAscending;
      }
      return isSortedAscending ? 'caret-up' : 'caret-down';
    } else {
      return null;
    }
  })
});